import type { ReactElement } from 'react';

import { ExternalIcon } from '@bestseller-bit/frontend-community.theme.buying-theme';
import Button, { type ButtonProps } from '@mui/material/Button';

import { useBI2Redirect } from '../../hooks/useBI2Redirect';

interface Bi2LinkButtonProps extends Omit<ButtonProps, 'children' | 'onClick'> {
    bi2Path: string;
}

const Bi2LinkButton = ({
    bi2Path,
    ...buttonProps
}: Bi2LinkButtonProps): ReactElement => {
    const redirectToBI2 = useBI2Redirect();

    return (
        <Button
            key="edit-in-bi2"
            variant="outlined"
            startIcon={<ExternalIcon />}
            {...buttonProps}
            onClick={() => {
                redirectToBI2(bi2Path);
            }}
        >
            Edit in BI2
        </Button>
    );
};

interface OrderBi2ButtonProps
    extends Omit<ButtonProps, 'children' | 'onClick'> {
    orderNumber: string;
}

const OrderBi2Button = ({
    orderNumber,
    ...buttonProps
}: OrderBi2ButtonProps): ReactElement => (
    <Bi2LinkButton
        bi2Path={`/PurchaseClient/orders/OrdersMainAction.do?orderNumber=${orderNumber}`}
        {...buttonProps}
    />
);

interface SampleOrderBi2ButtonProps
    extends Omit<ButtonProps, 'children' | 'onClick'> {
    sampleOrderNumber: string;
}

const SampleOrderBi2Button = ({
    sampleOrderNumber,
    ...buttonProps
}: SampleOrderBi2ButtonProps): ReactElement => (
    <Bi2LinkButton
        bi2Path={`/PurchaseClient/sampleOrders/SampleOrdersMainAction.do?sampleOrderNumber=${sampleOrderNumber}`}
        {...buttonProps}
    />
);

export { OrderBi2Button, SampleOrderBi2Button };
